import styled from '@emotion/styled'

const DefaultContentWrapper = styled('div')`
  @media (min-width: 1280px) {
    .default-content-image::after {
      display: block;
      position: relative;
      background-image: linear-gradient(
        to ${(props) => props.direction},
        transparent 10%,
        ${(props) => props.bg_color} 100%
      );
      margin-top: calc(70vw / -1.7777);
      height: calc(70vw / 1.7777);
      content: '';
    }
  }
`

export default DefaultContentWrapper
